itsoftApp.createModule("accordion", function() {
    var module = this;

    var initAccordions = function (accordion) {
        var $document = itsoftApp.commonVars.$document;
        var accordionType = accordion.getAttribute("data-type");
        var accordionHeadElements = accordion.querySelectorAll(".js-accordion-head");

        var onAccordionClick = function (evt) {
            var self = this;
            var selfPreventNone = self.hasAttribute("data-prevent-none");
            var selfOnce = self.hasAttribute("data-once");
            if (!selfPreventNone) {
                evt.preventDefault();
            }
            var activeItem;
            var currentItem;

            // стили находятся в файле /assets/styles/page.styl

            var closeAccordion = function (el) {
                var accordionContent = activeItem.querySelector(".js-accordion-content");
                var accordionItem = activeItem;
                var closedText = accordionItem.getAttribute("data-closed-text");
                activeItem.classList.add("js-accordion-item--close-ready");
                var height = accordionContent.clientHeight + "px";
                accordionContent.style.height = height;
                if (closedText) {
                    activeItem.textContent = closedText;
                }

                var onTransitionEnd = function () {
                    accordionItem.classList.remove("js-accordion-item--active");
                    accordionItem.classList.remove("js-accordion-item--close-ready");
                    accordionContent.removeEventListener("transitionend", onTransitionEnd);
                };

                accordionContent.addEventListener("transitionend", onTransitionEnd);

                requestAnimationFrame(function () {
                    requestAnimationFrame(function () {
                        accordionContent.style.height = "0px";
                    });
                });
            }

            var openAccordion = function (el) {
                var accordionContent = currentItem.querySelector(".js-accordion-content");
                var openedText = currentItem.getAttribute("data-opened-text");
                var accordionItem = currentItem;

                if (openedText) {
                    currentItem.textContent = openedText;
                }
                accordionItem.classList.add("js-accordion-item--open-ready");
                accordionContent.style.height = "auto";
                var height = accordionContent.clientHeight + "px";
                accordionContent.style.height = "0px";

                var onTransitionEnd = function () {
                    if (accordionType !== "any") {
                        itsoftApp.modules.animateScroll.callback(accordionItem, null, 2000, null, "easeOutQuad");
                    }
                    accordionItem.classList.remove("js-accordion-item--open-ready");
                    accordionItem.classList.add("js-accordion-item--active");
                    accordionContent.removeEventListener("transitionend", onTransitionEnd);
                };

                accordionContent.addEventListener("transitionend", onTransitionEnd);

                requestAnimationFrame(function () {
                    requestAnimationFrame(function () {
                        accordionContent.style.height = height;
                    });
                });
            }

            if (this.closest(".js-accordion-item--active")) {
                activeItem = this.closest(".js-accordion-item");
                closeAccordion();
                accordion.classList.remove("js-accordion--active");
            } else {
                if (accordionType !== "any") {
                    activeItem = accordion.querySelector(".js-accordion .js-accordion-item--active");
                    if (activeItem) {
                        closeAccordion();
                    }
                }

                currentItem = self.closest(".js-accordion-item");
                openAccordion();
                accordion.classList.add("js-accordion--active");
            }

            if (selfOnce) {
                self.removeEventListener("click", onAccordionClick);
            }
        }

        Array.prototype.forEach.call(accordionHeadElements, function (el) {
            el.addEventListener("click", onAccordionClick);
        });
    }

    var changeableElements = document.querySelectorAll("[data-change-vw]");

    if (changeableElements) {
        var currentViewport = itsoftApp.utils.getViewportSize();

        Array.prototype.forEach.call(changeableElements, function (changeableElement) {
            var direction = changeableElement.getAttribute("data-change-direction");

            if (!direction) {
                return;
            }

            if (direction === "from" && currentViewport >= +(changeableElement.getAttribute("data-change-vw"))) {
                var accordion = changeableElement.closest(".js-accordion");
                changeableElement.classList.add("js-accordion-item--active");
                accordion.classList.add("js-accordion--active");
            }
        });
    }

    module.callback = initAccordions;
});